import { useTranslation } from "@opendash/i18n";
import { Icon } from "@opendash/icons";
import { Alert, Button, Calendar, Col, Flex, Form, Input, Radio, Row, Space, Tag, Tooltip, } from "antd";
import dayjs from "dayjs";
import { runInAction } from "mobx";
import React, { useEffect, useMemo, useState } from "react";
import styled from "styled-components";
import { TimeSeriesDaily, TimeSeriesMonthlyDate, TimeSeriesMonthlyDay, TimeSeriesMonthlyInput, TimeSeriesWeeklyInput, TimeSeriesYearlyInput, WeekdaysSelectMultiple, } from "..";
import { StateProvider } from "../services/StateProvider";
const ActiveCell = styled.div `
  margin: 2px;
  padding: 2px;
  background-color: #ffffff;
  white-space: nowrap;

  .ant-alert {
    margin: 0;
    padding: 0;
  }
`;
const InactiveCurrentMonthCell = styled.div `
  margin: 2px;
  background-color: #eeeeee;
  padding: 2px;
  border: 1px solid #eeeeee;
  white-space: nowrap;
`;
const InactiveCell = styled.div `
  margin: 2px;
  background-color: #ffffff;
  padding: 2px;
  border: 1px solid #eeeeee;
  white-space: nowrap;
`;
export function useEditorItems(props) {
    const t = useTranslation();
    const [reloadString, setReloadString] = useState(0);
    const state = useMemo(() => StateProvider.getState(), []);
    // const iterator = useGenerator<Dayjs>(state, cronIterator);
    const [items, setItems] = useState([]);
    //#region Initial State
    useEffect(() => {
        runInAction(() => {
            var _a;
            if (typeof props.value !== "undefined") {
                state.startdate =
                    typeof props.value.run_startdate !== "undefined"
                        ? dayjs(props.value.run_startdate)
                        : dayjs();
                state.onlyWeeks = (_a = props.value.is_week) !== null && _a !== void 0 ? _a : false;
                if (typeof props.value.run_cron !== "undefined") {
                    state.cronStringToState(props.value.run_cron);
                }
            }
        });
    }, []);
    useEffect(() => {
        // Recalculate the crontab string when a value changes
        state.objectToString();
        if (props.onChange instanceof Function) {
            props.onChange({
                run_cron: state.cronstring,
                run_startdate: new Date(state.startdate.toISOString()),
                run_enddate: state.timeSeries === "once"
                    ? new Date(state.startdate.toISOString())
                    : state.currentEnddate
                        ? new Date(state.currentEnddate.toISOString())
                        : undefined,
                is_week: state.onlyWeeks,
                week_interval: state.weekInterval,
            });
        }
    }, [reloadString]);
    useEffect(() => {
        setReloadString((curr) => curr + 1);
    }, [
        state.startdate,
        state.currentEnddate,
        state.onlyWeeks,
        state.timeSeries,
        state.monthlySwitcher,
        state.selectedMonthInCalendar,
        state.selectedYearInCalendar,
        state.quartzobject.seconds,
        state.quartzobject.minutes,
        state.quartzobject.hours,
        state.quartzobject.dayofmonth,
        state.quartzobject.dayofweek,
        state.quartzobject.month,
        state.quartzobject.year,
    ]);
    //#endregion
    //TODO
    function resetConfig() {
        // state.quartzobject.reset();
        // switch (state.timeSeries) {
        //   case 1:
        //     state.currentEnddate = state.startdate;
        //     props.reset(["daily", "enddate"]);
        //     break;
        //   case 2:
        //     state.selectedWeekdays = [dayjs().weekday()];
        //     props.reset(["weekly", "weekday_select"]);
        //     break;
        //   case 3:
        //     state.selectedWeekdays = [dayjs().weekday()];
        //     props.reset(["monthly_date", "monthly_day", "monthly_series"]);
        //     break;
        //   case 4:
        //     props.reset(["yearly"]);
        //     break;
        //   default:
        //     setReloadString((curr) => curr + 1);
        //     break;
        // }
    }
    function getTimeSeries() {
        switch (state.timeSeries) {
            case "once":
                // props.reset([]);
                return null;
            case "daily":
                return (React.createElement(Form.Item, { name: "daily", initialValue: state.quartzobject.getInitialFormValue("daily") },
                    React.createElement(TimeSeriesDaily, { onChange: (value) => {
                            state.setField("DAYOFMONTH", value);
                            setReloadString((curr) => curr + 1);
                        }, onlyWeeks: state.onlyWeeks })));
            case "weekly":
                return (React.createElement(React.Fragment, null,
                    React.createElement(Form.Item, { name: "weekday_select", initialValue: state.quartzobject.getInitialFormValue("weekday_select") },
                        React.createElement(WeekdaysSelectMultiple, { onChange: (value) => {
                                state.setField("DAYOFWEEK", value);
                                setReloadString((curr) => curr + 1);
                            }, multiple: true, onlyWeeks: state.onlyWeeks })),
                    React.createElement(Form.Item, { name: "weekly", initialValue: state.quartzobject.getInitialFormValue("daily") },
                        React.createElement(TimeSeriesWeeklyInput, { onChange: (value) => {
                                state.weekInterval = value;
                                setReloadString((curr) => curr + 1);
                            } }))));
            case "monthly":
                return (React.createElement(React.Fragment, null,
                    state.onlyWeeks === false ? (React.createElement(Flex, { align: "start", justify: "center", style: { marginBottom: 12 } },
                        React.createElement(Radio.Group, { onChange: (e) => (state.monthlySwitcher = e.target.value), value: state.monthlySwitcher, optionType: "button", buttonStyle: "solid" },
                            React.createElement(Radio, { value: 1 }, t("maintenance:schedule.create.form.seriespattern.monthly.value1")),
                            React.createElement(Radio, { value: 2 }, t("maintenance:schedule.create.form.seriespattern.monthly.value2"))))) : null,
                    state.onlyWeeks === false && state.monthlySwitcher === 1 ? (React.createElement(Form.Item, { name: "monthly_date", initialValue: state.quartzobject.getInitialFormValue("monthly_date") },
                        React.createElement(TimeSeriesMonthlyDate, { onChange: (value) => {
                                state.setField("DAYOFMONTH", value);
                                setReloadString((curr) => curr + 1);
                            } }))) : null,
                    state.onlyWeeks === false && state.monthlySwitcher === 2 ? (React.createElement(Row, { justify: "space-between", align: "middle" },
                        React.createElement(Col, { span: 11 },
                            React.createElement(Form.Item, { name: "monthly_day", initialValue: state.quartzobject.getInitialFormValue("monthly_day") },
                                React.createElement(TimeSeriesMonthlyDay, { onChange: (value) => {
                                        state.setField("DAYOFWEEK", value);
                                        setReloadString((curr) => curr + 1);
                                    } }))),
                        React.createElement(Col, { span: 11 },
                            React.createElement(Form.Item, { name: "weekday_select", initialValue: state.quartzobject.getInitialFormValue("weekday_select") },
                                React.createElement(WeekdaysSelectMultiple, { onChange: (value) => {
                                        state.setField("DAYOFWEEK", value);
                                        setReloadString((curr) => curr + 1);
                                    }, multiple: false, onlyWeeks: state.onlyWeeks }))))) : null,
                    React.createElement(Form.Item, { name: "monthly_series", initialValue: state.getFormValueFromCronString("monthly_series") },
                        React.createElement(TimeSeriesMonthlyInput, { onChange: (value) => {
                                state.setField("MONTH", value);
                                setReloadString((curr) => curr + 1);
                            } }))));
            case "yearly":
                return (React.createElement(Form.Item, { name: "yearly", initialValue: state.getFormValueFromCronString("yearly") },
                    React.createElement(TimeSeriesYearlyInput, { onChange: (value) => {
                            state.setField("YEAR", value);
                            setReloadString((curr) => curr + 1);
                        } })));
        }
    }
    useEffect(() => {
        const newitems = [];
        newitems.push({
            key: 1,
            label: t("maintenance:schedule.create.form.collapse.configuration"),
            children: state.timeSeries !== "once" ? (getTimeSeries()) : (React.createElement("p", null, t("maintenance:schedule.create.form.collapse.noconfiguration"))),
            // extra: (
            //   <Tooltip
            //     title={t(
            //       "maintenance:schedule.create.form.seriespattern.button.reset"
            //     )}
            //   >
            //     <Button
            //       icon={<Icon icon="fa:undo" />}
            //       type="text"
            //       onClick={(event) => {
            //         event.stopPropagation();
            //         resetConfig();
            //       }}
            //     ></Button>
            //   </Tooltip>
            // ),
        });
        if (props.showCalendar) {
            newitems.push({
                key: 2,
                label: t("maintenance:schedule.create.form.collapse.calendar"),
                children: (React.createElement(Calendar, { fullCellRender: (value) => {
                        if (state.fitsDate(value)) {
                            return (React.createElement(ActiveCell, null,
                                React.createElement(Alert, { type: "success", message: value.format("DD.MM.") })));
                        }
                        if (value.get("month") === state.selectedMonthInCalendar) {
                            return React.createElement(InactiveCell, null, value.format("DD.MM."));
                        }
                        return (React.createElement(InactiveCurrentMonthCell, null, value.format("DD.MM.")));
                    }, validRange: [
                        dayjs({
                            second: 0,
                            minute: 0,
                            hour: 0,
                            day: 1,
                            month: 0,
                            year: 1970,
                        }),
                        //This is just the maximum date that can be displayed in the calendar
                        //Converted from unix time
                        dayjs(new Date(8640000000000000)),
                    ], onPanelChange: (value, mode) => {
                        state.selectedMonthInCalendar = value.get("month");
                        state.selectedYearInCalendar = value.get("year");
                        setReloadString((curr) => curr + 1);
                    }, fullscreen: false })),
            });
        }
        newitems.push({
            key: 3,
            label: t("maintenance:schedule.create.form.collapse.nextdates"),
            children: state.timeSeries === "once" ? (React.createElement(Flex, { align: "flex-start", justify: "center", wrap: "wrap", gap: 12 },
                React.createElement(Tag, null, state.onlyWeeks
                    ? state.startdate.format(`[${t("maintenance:schedule.calendarweek.abbreviation")}] WW in YYYY`)
                    : state.startdate.format("DD.MM.YYYY HH:mm")))) : (React.createElement(React.Fragment, null,
                React.createElement(Flex, { vertical: false, align: "center", justify: "center", wrap: "wrap", gap: 12 },
                    React.createElement(Flex, { align: "flex-start", justify: "center", wrap: "wrap", gap: 12 }, state.nextDates(9).map((date) => (React.createElement(Tag, { key: date.toISOString() }, state.onlyWeeks
                        ? date.format(`[${t("maintenance:schedule.calendarweek.abbreviation")}] WW in YYYY`)
                        : date.format("DD.MM.YYYY HH:mm"))))),
                    React.createElement(Flex, { align: "flex-start", justify: "center", wrap: "wrap", gap: 12 },
                        React.createElement(Tag, { key: "andsoforth" }, ". . ."))))),
        });
        if (props.showCron && state.timeSeries !== "once") {
            newitems.push({
                key: 4,
                label: t("maintenance:schedule.create.form.collapse.cron"),
                children: (React.createElement(Row, { align: "middle", justify: "center" },
                    React.createElement(Col, null,
                        React.createElement(Space.Compact, null,
                            React.createElement(Input, { addonBefore: React.createElement(Icon, { icon: "fa:clock" }), value: state.cronstring, disabled: true }))),
                    React.createElement(Col, null,
                        React.createElement(Tooltip, { title: state.cronstringcopied ? "Kopiert" : "Kopieren" },
                            React.createElement(Button, { icon: React.createElement(Icon, { icon: "fa:copy" }), onClick: () => {
                                    navigator.clipboard.writeText(state.cronstring);
                                    state.cronstringcopied = true;
                                } }))))),
            });
        }
        setItems(newitems);
    }, [reloadString]);
    return [state, items];
}
//# sourceMappingURL=useEditorItems.js.map